const ChartReadyMixin = {
  data () {
    return {
      ready: false
    }
  },

  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.ready = true
      }, 234)
    })
  }
}

export default ChartReadyMixin
